import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { CentralizedLevels } from "./Levels/Levels";
import { CentralizedPassenger } from "./Passenger/Passenger";
import { CentralizedPublic } from "./Public/Public";

export const CentralizedZone = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const [currentAirport] = useLocalStorage("currentAirport", null);

  const isKlia = currentAirport === "klia1" || currentAirport === "klia2";

  const tabItems = [
    {
      label: "Public",
      key: "centralizedZonePublic",
      children: <CentralizedPublic />,
    },
    {
      label: "Passenger",
      key: "centralizedZonePassenger",
      children: <CentralizedPassenger />,
    },
    {
      label: "Levels",
      key: "centralizedZoneLevels",
      children: <CentralizedLevels />,
    },
  ];

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={tabItems}
      onChange={(activeKey) => {
        let url = `${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`;
        navigate(url);
      }}
    />
  );
};
